export function getCheatUIStyles() {
  return {
    popup: `
     width: 100%;
      max-width: 400px;
      position: absolute;
      top: 10px;
      left: 50%;
      transform: translateX(-50%);
      border: none;
      border-radius: 8px;
      background-color: rgba(28, 28, 28, 0.95);
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
      display: none;
      z-index: 9999;
      font-family: Arial, sans-serif;
    `,
    headerStyle: `
      padding: 8px 16px;
      background-color: rgba(0, 0, 0, 0.2);
      border-radius: 8px 8px 0 0;
      cursor: move;
      display: flex;
      justify-content: space-between;
      align-items: center;
    `,
    buttonContainerStyle: `
      display: flex;
      gap: 8px;
    `,
    headerButtonStyle: `
      background: none;
      border: none;
      color: white;
      cursor: pointer;
      padding: 4px;
      font-size: 16px;
      line-height: 1;
      opacity: 0.7;
      transition: opacity 0.2s;
    `,
    buttonStyle: `
      background-color: #4a4a4a;
      color: white;
      border: none;
      border-radius: 4px;
      padding: 6px 12px;
      margin: 4px;
      cursor: pointer;
      font-size: 12px;
      transition: background-color 0.2s;
    `,
    selectStyle: `
      background-color: #3a3a3a;
      color: white;
      border: 1px solid #555;
      border-radius: 4px;
      padding: 4px 8px;
      margin: 4px;
      cursor: pointer;
      font-size: 12px;
      min-width: 150px;
    `,
    inputStyle: `
      background-color: #3a3a3a;
      color: white;
      border: 1px solid #555;
      border-radius: 4px;
      padding: 6px 12px;
      margin: 4px;
      font-size: 12px;
      width: calc(100% - 32px);
    `,
    sectionStyle: `
      background-color: rgba(255, 255, 255, 0.05);
      border-radius: 6px;
      padding: 12px;
      margin-bottom: 12px;
    `,
  };
}
